import { api } from './api'
import * as webLMSApi from './webLMS.api'

const middleware = {
  middleware: (getDefaultMiddleware: any): any =>
    getDefaultMiddleware().concat(api.middleware, webLMSApi.api.middleware),
}

export default middleware
